import { ArrowRight } from "lucide-react";

import { t } from "../i18n/i18n";

/** Schéma du déroulement de la rotation CENTAC (fiche d'aide « ordre.centac ») : les quatre OPO, chacun validé
 *  puis ses résultats saisis, reliés par les WINGO qui rédigent l'OPO suivant ; les FRAGO, facultatifs, sous
 *  chaque OPO validé. */
export function RotationFlowFigure() {
  const opos = [1, 2, 3, 4];
  return (
    <figure className="rounded-lg border border-line bg-canvas px-3 py-2.5" aria-label={t("Déroulement de la rotation")}>
      <ol className="flex flex-wrap items-stretch gap-1.5">
        {opos.map((n) => (
          <li key={n} className="flex items-stretch gap-1.5">
            <div className="flex min-w-28 flex-col gap-1 rounded-md border border-line-strong bg-surface px-2 py-1.5">
              <span className="text-ui font-semibold text-ink">{t("OPO N°{n}", { n })}</span>
              <span className="text-meta leading-snug text-ink-soft">{t("Validation")} · {t("Résultats")}</span>
              <span className="text-meta leading-snug text-ink-muted">{t("FRAGO N°{n} et suivants", { n: n * 10 + 2 })}</span>
            </div>
            {n < opos.length && (
              <div className="flex flex-col items-center justify-center gap-0.5 px-0.5 text-meta text-ink-muted">
                <span className="font-medium text-accent">{t("WINGO N°{w}", { w: (n + 1) * 10 + 1 })}</span>
                <ArrowRight size={14} aria-hidden />
              </div>
            )}
          </li>
        ))}
      </ol>
      <figcaption className="pt-1.5 text-meta leading-snug text-ink-muted">
        {t("Le WINGO rédige l'OPO suivant d'après les résultats saisis ; un FRAGO modifie l'OPO validé en cours d'exécution.")}
      </figcaption>
    </figure>
  );
}
